export default __webpack_public_path__ + "static/media/powerbilogo.649554e0.png";